import { FC, useEffect, useState, useRef } from 'react';
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { useDispatch } from 'react-redux';
import { FormProvider, useForm } from "react-hook-form";
import { Box, Paper, Typography, TextField, CardContent, Grid, Drawer, Stack, Avatar, CircularProgress, Tooltip, SelectChangeEvent, FormControl, InputLabel, InputAdornment, OutlinedInput, Divider, Chip, Autocomplete, Button, Table, TableHead, TableRow, TableBody, TableCell, tableCellClasses, MenuItem, Select, IconButton, TableContainer, TableFooter, ToggleButton, Alert, Badge, Popover, List, ListItem, ListItemText, ListItemButton } from '@mui/material';
import { makeStyles } from "@material-ui/core/styles";
import SettingsIcon from '@mui/icons-material/Settings';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import CustomTextField from "../../components/FormFields/CustomTextField";
// import TableInlineEdit from '../Table/TableInlineEdit';
import DialogClientForm from '../Dialog/CreateClientForm';
import DialogDocumentSettingForm from '../../components/DialogDocumentSettingForm/DialogDocumentSettingForm';
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { StyledCard } from '../AccountBasicInfo/AccountBacisInfo.styles';
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { fetchInvoiceSeqNumber, addInvoice, fetchInvoiceById, updateInvoice, dispatchInvoice } from '../../store/invoiceStore/invoiceThunk';
import { fetchAccountById, fetchAccounts, fetchCounterPartyAccountById, fetchAccountsByName } from "../../store/accountThunk";
import { fetchDocumentSettings } from '../../store/documentSettingStore/documentSettingThunk';
import { InvoiceFormInputs } from "../../utils/invoice.types";
import DocAttachInfo from '../DocumentAttachment/DocAttachInfo';
import PayTo from './PayTo';
import InvoiceButtons from './InvoiceFooterButtons';
import TemplateSelect from './TemplateSelect'
import { StyledBoxLoader } from './Invoice.style';
import { Utils, InvoiceRoute, VocuherCategory, VocuherTypes } from "../../utils/common-utils";
import moment from 'moment';
import './Invoice.css'

import { fetchStates } from '../../store/stateStore/stateThunk';
import { fetchUnits } from '../../store/unitsStore/unitsThunk';
import CustomSelect, { IOptions } from "../FormFields/CustomSelect";
import { experimentalStyled as styled } from '@mui/material/styles';
import { toast } from 'react-toastify';
import { on } from 'cluster';
import { AccountCircle, CheckCircleOutline, CurrencyRupee, PersonSearchRounded } from '@mui/icons-material';
import { Divide, SearchCheckIcon } from 'lucide-react';
import { DatePicker } from '@mui/x-date-pickers';
import HighlightOffTwoToneIcon from '@mui/icons-material/HighlightOffTwoTone';
import ModeEditOutlineOutlinedIcon from '@mui/icons-material/ModeEditOutlineOutlined';
import RemoveCircleOutlineOutlinedIcon from '@mui/icons-material/RemoveCircleOutlineOutlined';
import AddCircleOutlineOutlinedIcon from '@mui/icons-material/AddCircleOutlineOutlined';
import ArrowCircleDownIcon from '@mui/icons-material/ArrowCircleDown';
import CheckIcon from '@mui/icons-material/Check';
import BuyerModel from './BuyerModel';
import InvoiceElements  from './InvoiceElements';
import {InvoiceElementsInterface} from './InvoiceElementInterface';
import ItemModel from './ItemModel';
import BankChanges from './BankChange';
import { fetchGstOptions } from '../../store/gstStore/gstThunk';
import { fetchInventoryById } from '../../store/inventoryStore/inventoryThunk';
import { AddBox, Clear, Check, Edit, Delete} from "@mui/icons-material";


interface TableInlineEditProps {
  onChangeLineItemRow: (data: any) => void;
  rowsData?: any[];
  isInvoiceTaxTypeIgst: boolean;
  voucherType?: string;
  onLocationSelect?: (locationId: string) => void;
}

interface lineItemSubTotal {
  discount: number;
  tax: number;
  amount: number;
  finalAmount : number;
}

const createLineItem = (
  editable:Boolean, id:number, name: string, description:string, hsnCode: string, mrp:number, unit:string,
  qty:number, appliedRate:number, discountPercentage:number, discount:number, amount:number, taxPercentage:number,
  igst:number, igsttotal:number, cgst:number, cgsttotal:number, sgst:number, sgsttotal:number,
  total:number, _id:string, skuCode: string) => (
  {
    editable, id, name, description, hsnCode, mrp, unit, qty, appliedRate, discountPercentage, discount, amount,
    taxPercentage, igst, igsttotal, cgst, cgsttotal, sgst, sgsttotal, total, _id, skuCode
  }
);

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: '#f5f5f5',
    color: "#000",
    border: '0.01px dashed #d9d4d4',
    borderLeft:'none'
  },
  [`&.${tableCellClasses.footer}`]: {
    backgroundColor: '#f5f5f5',
    color: "#000",
    border: '0.01px dashed #d9d4d4',
    borderLeft:'none',
    left: 0,
    bottom: 0, // <-- KEY
    zIndex: 2,
    position: 'sticky'
  },
  [`&.${tableCellClasses.body}`]: {
    verticalAlign: 'super',
    fontSize: 14,
    border: '0.01px dashed #d9d4d4',
    padding: 5,
    borderLeft:'none',
    borderTop:'none'
  },
}));
  
const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    // backgroundColor: theme.palette.action.hover,
    // border: '0.5px dashed #9da7b7',
  },
  // hide last border
  // '&:last-child td, &:last-child th': {
  '&:last-child td, &:last-child th': {
    borderBottom:'none'
  },
}));

const useStyles = makeStyles({
  paper: {
    border: "1.5px solid #e9ecf1",
    boxShadow: 'none',
    borderRadius: 7
  },
  toggleButtonGroup: {
    width: '100%',
  },
  toggleButton: {
    width: 15,
    height: 15,
    marginBottom: 2
  },

});


const TableInlineEdit3: FC<TableInlineEditProps> = ({ onChangeLineItemRow, rowsData, isInvoiceTaxTypeIgst, voucherType, onLocationSelect }) => {
  const isCreditNote = voucherType === VocuherTypes.CREDIT_NOTE;

    

  const [rows, setRows] = useState<any[]>([]);
  const [taxType, setTaxType] = useState<boolean>(isInvoiceTaxTypeIgst || false);
  const classes = useStyles();
  const scrollRef = useRef<null | HTMLDivElement>(null);
  const dispatch = useAppDispatch();
  const dispatch1 = useDispatch();

  // Measuring units master — for the per-line Unit dropdown.
  const { units: measuringUnits, byId: unitsById } = useAppSelector((state: any) => state.units);
  useEffect(() => {
    if (!measuringUnits || measuringUnits.length === 0) dispatch(fetchUnits());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Options for a line's Unit select: the units configured on that item (base unit
  // + packs from unitConversions) when available, otherwise the whole unit master.
  const unitOptionsFor = (e: any) => {
    const idOf = (v: any) => (v && typeof v === 'object' ? v._id : v);
    const ids: string[] = [];
    const baseId = idOf(e.baseUnit);
    if (baseId) ids.push(String(baseId));
    if (e.unitConversions) Object.keys(e.unitConversions).forEach((k) => ids.push(String(k)));
    const uniq = Array.from(new Set(ids.filter(Boolean)));

    let opts = uniq
      .map((id) => unitsById?.[id])
      .filter(Boolean)
      .map((u: any) => ({ value: u.code || u.name, label: `${u.name}${u.code ? ` (${u.code})` : ''}` }));

    // No units configured on the item → offer the full master list.
    if (opts.length === 0) {
      opts = (measuringUnits || []).map((u: any) => ({
        value: u.code || u.name,
        label: `${u.name}${u.code ? ` (${u.code})` : ''}`,
      }));
    }
    // Keep the currently-stored unit selectable even if it's not in the list.
    if (e.unit && !opts.find((o: any) => o.value === e.unit)) {
      opts = [{ value: e.unit, label: e.unit }, ...opts];
    }
    return opts;
  };

  // Base units contained in 1 of `unitCode` for item `e`. Base unit = 1; pack units
  // come from unitConversions (keyed by unit id). Units are matched by code or name.
  const unitFactorFor = (e: any, unitCode: string) => {
    if (!unitCode) return 1;
    const idOf = (v: any) => (v && typeof v === 'object' ? v._id : v);
    const baseId = idOf(e.baseUnit);
    const baseU = baseId ? unitsById?.[baseId] : null;
    if ((baseU && (baseU.code === unitCode || baseU.name === unitCode)) || e.baseUnitName === unitCode) return 1;
    if (e.unitConversions) {
      for (const id of Object.keys(e.unitConversions)) {
        const u = unitsById?.[id];
        if (u && (u.code === unitCode || u.name === unitCode)) return Number(e.unitConversions[id]) || 1;
      }
    }
    return 1;
  };

  // Changing a line's unit rescales its price by the conversion factor so the base
  // price per base unit stays constant (e.g. ₹0.67/MLT -> ₹670/BTL when 1 BTL = 1000
  // MLT), then recalculates discount/amount/tax for the row.
  const changeLineUnit = (row: any, newUnit: string) => {
    const oldF = unitFactorFor(row, row.unit) || 1;
    const newF = unitFactorFor(row, newUnit) || 1;
    const ratio = oldF > 0 ? newF / oldF : 1;
    // Rescale MRP and the sale price INDEPENDENTLY so their gap (the discount) is
    // preserved across the unit change — never collapse them to one value.
    const round2 = (n: number) => Math.round(n * 100) / 100;
    const newMrp = round2((Number(row.mrp) || 0) * ratio);
    const newSale = round2((Number(row.appliedRate) || 0) * ratio);
    setRows((prev: any) => prev.map((r: any) => (r.id === row.id
      ? rowReCalculatioForInventory({ ...r, unit: newUnit, mrp: newMrp, appliedRate: newSale })
      : r)));
  };

  const [itemModel, setItemModel] = useState(false);
  const [itemAmt, setItemAmt] = useState(0);
  const [len, setLen] = useState(0);
  const [gstOptions, setGstOptions] = useState<any[]>([]);
  const [subTotal, setSubTotal] = useState({
    discount: 0,
    tax: 0,
    amount: 0,
    finalAmount : 0
  })

  useEffect(() => {
    let rowCount = 0;
    let _taxType = false;
    setRows([]);
    // if(rows.length==0 && rowsData) {
    if(rowsData && rowsData.length>0) {
      rowsData.forEach((row) => {
        ++rowCount;
        _taxType = (row.igst > 0 && row.igsttotal ) ? true : false;
        let _row = {
          id:rowCount,
          seqNumber: row.seqNumber ? row.seqNumber : rowCount,
          name: row.name,
          description: row.description,
          hsnCode: row.hsnCode,
          mrp: row.mrp,
          unit: row.unit,
          qty: row.qty,
          soldQty: row.soldQty != null ? row.soldQty : row.qty, // original invoice qty (return cap)
          soldUnit: row.soldUnit != null ? row.soldUnit : row.unit, // unit soldQty is expressed in (for base-unit conversion)
          appliedRate: row.appliedRate,
          discountPercentage:row.discountPercentage,
          discount:row.discount,
          amount: row.amount,
          taxPercentage: row.taxPercentage,
          igst: row.igst,
          igsttotal: row.igsttotal,
          cgst: row.cgst,
          cgsttotal: row.cgsttotal,
          sgst: row.sgst,
          sgsttotal: row.sgsttotal,
          total: row.total,
          _id: row._id,
          skuCode: row.skuCode,
          baseUnit: row.baseUnit,
          baseUnitName: row.baseUnitName,
          unitConversions: row.unitConversions,
          // Preserve the picked batch/location across the edit-mode rebuild so a
          // re-save keeps depleting the same batch (seed from the persisted
          // batchId when an existing invoice's line items are loaded).
          cardBatchId: row.cardBatchId || row.batchId || null,
          cardLocationId: row.cardLocationId || row.locationId || null,
        }
        // let _row = createData(rowCount, row.name, row.description, row.spec, row.hsnCode, row.unit, row.qty, row.appliedRate, row.discount, row.amount, row.igst, row.igsttotal, row.cgst, row.cgsttotal, row.sgst, row.sgsttotal, row.total, row._id, row.skuCode)
        setRows((rows: any) => ([...rows, _row]));
      });
    }

  }, [rowsData])

  // Back-fill unit chain for persisted rows missing it (e.g. credit note), keyed on skuCode.
  useEffect(() => {
    const missing = Array.from(new Set(
      rows.filter((r: any) => r.skuCode && !r.baseUnit && !r.unitConversions).map((r: any) => r.skuCode)
    ));
    if (missing.length === 0) return;
    let cancelled = false;
    Promise.all(missing.map((id: any) =>
      dispatch(fetchInventoryById(id)).unwrap().then((sku: any) => ({ id, sku })).catch(() => null)
    )).then((results: any[]) => {
      if (cancelled) return;
      const byId: any = {};
      results.filter(Boolean).forEach((r: any) => { byId[r.id] = r.sku; });
      setRows((prev: any) => prev.map((r: any) => {
        const sku = r.skuCode && byId[r.skuCode];
        if (!sku || r.baseUnit || r.unitConversions) return r;
        return { ...r, baseUnit: sku.baseUnit, baseUnitName: sku.baseUnitName, unitConversions: sku.unitConversions };
      }));
    });
    return () => { cancelled = true; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rows.length])

  useEffect(() => {
    dispatch(fetchGstOptions()).unwrap().then(async (data) => {
      if (data) {
        // if (data.length > 0) {
        //   await data.forEach(async (item: string | any) => {
        //     setGstOptions(([...gstOptions, { label: item.lable, value: item._id }]));
            console.log(data);
            setGstOptions(data);
          // });
        // }
      }
    });
  }, []);

  useEffect(() => {
    setTaxType(isInvoiceTaxTypeIgst ? isInvoiceTaxTypeIgst : false);
  }, [isInvoiceTaxTypeIgst])
  

  useEffect(() => {
    if (rows && rows.length > len) {
      setLen(rows.length);
      dispatch1(()=> {
        scrollRef?.current?.scrollIntoView({ block: 'end', behavior: 'smooth'});
      })
    } else {
      setLen(Number(rows && rows.length));
    }
  }, [rows && rows.length, dispatch1]);

  useEffect(() => {
    let newRows;
    if (rows && rows.length > 0) {
      newRows = rows.map(row => {
        let amount = (row.qty * row.appliedRate) ;
        let _taxPercentage = row.taxPercentage;
        let discountedAmount = (amount * row.discountedPercentage) / 100;
        let taxedAmount = ((amount - (discountedAmount | 0)) * row.taxPercentage)/100;
        row.cgst = taxType ? 0 : Number(Number(_taxPercentage) / 2);
        row.sgst = taxType ? 0 : Number(Number(_taxPercentage) / 2);
        row.igst = taxType ? Number(_taxPercentage).toFixed(2) : 0;
        row.igsttotal = taxType ? Number(taxedAmount).toFixed(2) : Number(0);
        row.cgsttotal = taxType ? Number(0) : Number(Number(taxedAmount) / 2).toFixed(2)
        row.sgsttotal = taxType ? Number(0): Number(Number(taxedAmount) / 2).toFixed(2);
        return row;
      });
      setRows(newRows);
    }
  }, [taxType]);

  useEffect(() => {
    if (rows && rows.length > 0) {

      let sub_discount = Number();
      let sub_tax = Number();
      let sub_amount = Number();
      let sub_finalamount = Number();
      let appliedIgstTaxRates:any = [];
      let appliedCgstSgstTaxRates:any = [];

      rows.map((record:any) => {
        sub_discount = Number(sub_discount + Number(record.discount));
        sub_tax = Number(sub_tax + Number(record.igsttotal) + Number(record.sgsttotal) + Number(record.cgsttotal));
        sub_amount = Number(sub_amount + Number(record.amount));
        sub_finalamount = Number(sub_finalamount + Number(record.total));
        console.log("record.taxPercentage == ", record.taxPercentage);

        if(taxType) {
          if(record.taxPercentage > 0 || record.taxPercentage == 0) {
            appliedIgstTaxRates.push(`@${record.taxPercentage}%`);
            appliedCgstSgstTaxRates.push(``);
          }
        } else {
          if(record.taxPercentage > 0 || record.taxPercentage == 0) {
            appliedIgstTaxRates.push(``);
            // appliedCgstSgstTaxRates.push(record.taxPercentage);
            appliedCgstSgstTaxRates.push(`@${record.taxPercentage/2}%`);
          }
        }
      })
      setSubTotal({
        discount: isNaN(sub_discount) ? 0 : sub_discount,
        tax: isNaN(sub_tax) ? 0 : sub_tax ,
        amount: isNaN(sub_amount) ? 0 : sub_amount,
        finalAmount: isNaN(sub_finalamount) ? 0 : sub_finalamount
      })
      onChangeLineItemRow({ data: rows, values: {
        discount: isNaN(sub_discount) ? 0 : sub_discount,
        tax: isNaN(sub_tax) ? 0 : sub_tax ,
        amount: isNaN(sub_amount) ? 0 : sub_amount,
        finalAmount: isNaN(sub_finalamount) ? 0 : sub_finalamount,
        taxType: taxType,
        appliedIgstTaxRates: Array.from(new Set(appliedIgstTaxRates)),
        appliedCgstSgstTaxRates: Array.from(new Set(appliedCgstSgstTaxRates))
      }});

    } else {
      setSubTotal({
        discount: 0,
        tax: 0,
        amount: 0,
        finalAmount: 0
      })
      onChangeLineItemRow({ data: rows, values: {
        discount: 0,
        tax: 0,
        amount: 0,
        finalAmount: 0,
        taxType: taxType,
        taxes: [],
        appliedIgstTaxRates: [],
        appliedCgstSgstTaxRates: []
      }});
    }
  }, [rows, taxType, itemModel]);

  
  const AddCustomRow = ()=> {
    if(rows && rows.length >= 1) {
      const updatelist = rows.map((c:any) => {
          return {...c, editable: false };
      });
      var s:any[] = [{...rows}];
      var row_index_id = rows.length > 0 ? rows[rows.length - 1].id + 1 : 1
      const _temp_row = createLineItem(true, row_index_id, "", "", "", 0, "Nos", 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, "", "");
      s = [...updatelist, _temp_row];
      setRows(s);
    } else {
      var row_index_id = rows && rows.length > 0 ? rows[rows && rows.length - 1].id + 1 : 1
      const _temp_row = createLineItem(true, row_index_id, "", "", "", 0, "Nos", 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, "", "");
      setRows([...rows, _temp_row]);
    }
  }

  const RemoveRow = (id:number)=> {
    const newRows = rows.filter((obj) => obj.id !== id);
    setRows(newRows);
  // onChangeRow(newRows);
    // var s:any[] = [{...rows}];
    // s = s.filter((a:any) => a.id !== Id);
    // setRows(s);
  }

  const Editable = (id:number, editable:boolean) =>{
    const updatelist = rows && rows.map((c:any) => {
      if (c.id === id) {
        return {...c, editable: editable};
      } else {
        return {...c, editable: false};
      }
    });
    var s:any[] = [{...rows}];
    s = updatelist;
    setRows(s);
  }
  
  // Two picks are the "same line" only if they're the same SKU + batch + location
  // (a batch keeps its identity across locations, so batch alone isn't enough).
  // Falls back to matching by name for rows with no skuCode (manually typed lines).
  const sameCartLine = (a: any, e: any) =>
    (a.skuCode && e.skuCode)
      ? (a.skuCode === e.skuCode && (a.cardBatchId || null) === (e.cardBatchId || null) && (a.cardLocationId || null) === (e.cardLocationId || null))
      : a.name === e.name;

  function getData(data:any) {
    console.log("getData on change called componenet ", data);
    var newRows = rows;
    data.map((e:any) => {
      if(rows.find((i:any) => sameCartLine(i, e)))
      {
        console.log("Condition matched sameCartLine ");
        newRows.map((v:any, index:any)=> {
          if(sameCartLine(v, e)){
            console.log("Condition matched v.name === e.name ");
            console.log(v);
            // const _temp_row = createLineItem(false, index, v.name, v.description, v.hsnCode, e.mrp, v.unit, v.qty, v.applliedRate, v.discountPercentage, v.discount, 0, v.taxPercentage, 0, 0, 0, 0, 0, 0, 0, "", "");

            newRows[index] = {...v, qty:Number(v.qty)+Number(e.qty)}
            newRows[index] =  rowReCalculatioForInventory(newRows[index])
            console.log(newRows[index]);
            // newRows[index] = {...v, qty:Number(v.qty)+Number(e.qty)}
          }
        });
        // setRows(s);
      }else {
        console.log("outside if seeting empty rows");
        var row_index_id = newRows && newRows.length > 0 ? newRows[newRows && newRows.length - 1].id + 1 : 1
        // const _temp_row = createLineItem(false, row_index_id, "", "", "", 0, "Nos", 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, "", "");
        e =  rowReCalculatioForInventory(e)
        console.log(e);
        newRows = [...newRows, {...e, id: row_index_id}];
      }
    })
    setRows(newRows);
  }

  const setInvoiceItemText =(value:any, field:string, Id:any) => {
    const item:any = [];
    rows && rows.map((o:any) => {
      if (o.id===Id) {
        item.push({...o, [field]: value});
      }else {
        item.push(o);
      }
    })
    var s:any[] = [{...rows}];
    s = item;
    console.log(s);
    setRows(s);
    
  }

  const onChange = (e: any, row: any, type: string) => {
    let value = (type !== 'number') ? e.target.value : (type === 'number' && e.target.value >= 0) ? Number(e.target.value) : 0;
    const name = e.target.name;
    const { id } = row;

    // credit note: returned qty cannot exceed the qty sold — compared in BASE units so a
    // return in a smaller unit (e.g. tablets) is capped against the sold bottles correctly.
    if (isCreditNote && name === 'qty' && row.soldQty != null) {
      const soldBase = Number(row.soldQty) * unitFactorFor(row, row.soldUnit || row.unit);
      const returnBase = Number(value) * unitFactorFor(row, row.unit);
      if (returnBase > soldBase) {
        const maxInCurrentUnit = soldBase / (unitFactorFor(row, row.unit) || 1);
        toast.warn(`Cannot return more than sold. Sold quantity is ${row.soldQty} ${row.soldUnit || row.unit}.`);
        value = maxInCurrentUnit;
      }
    }

    const newRows = rows.map(row => {
      if (row.id === id) {
        let _qty = (name === 'qty') ? value : Number(row.qty);
        let _mrp = (name === 'mrp') ? value : Number(row.mrp);
        let _appliedRate = (name === 'appliedRate') ? value : Number(row.appliedRate);
        let _discountPercentage = (name === 'discountPercentage') ? value : Number(row.discountPercentage);
        let _discount = (name === 'discount') ? value : Number(row.discount);
        let _taxPercentage = (name === 'taxPercentage') ? value : Number(row.taxPercentage);

        // Fallback for Price/Item if it was never set but MRP is present
        if (name !== 'mrp' && name !== 'appliedRate' && _appliedRate === 0 && _mrp > 0 && _discountPercentage === 0) {
           _appliedRate = _mrp;
        }

        // Handle calculation logic based on which field was changed
        if (name === 'discountPercentage') {
          const discountPerItem = (_mrp * _discountPercentage) / 100;
          _appliedRate = Number((_mrp - discountPerItem).toFixed(2));
          _discount = Number((discountPerItem * _qty).toFixed(2));
        } else if (name === 'discount') {
          const totalBaseAmount = _qty * _mrp;
          if (totalBaseAmount > 0) {
            _discountPercentage = Number(((_discount / totalBaseAmount) * 100).toFixed(2));
          } else {
            _discountPercentage = 0;
          }
          const discountPerItem = _qty > 0 ? _discount / _qty : 0;
          _appliedRate = Number((_mrp - discountPerItem).toFixed(2));
        } else if (name === 'appliedRate') {
          // Price/Item can't exceed MRP — that would make the discount negative.
          // Cap it to MRP and tell the user to raise MRP if they need a higher price.
          if (_mrp > 0 && _appliedRate > _mrp) {
            toast.warn('Price/Item cannot be greater than MRP. Please increase the MRP for a higher price.');
            _appliedRate = _mrp;
            value = _appliedRate;
          }
          if (_mrp > 0) {
            const discountPerItem = _mrp - _appliedRate;
            _discount = Number((discountPerItem * _qty).toFixed(2));
            _discountPercentage = Number(((discountPerItem / _mrp) * 100).toFixed(2));
          } else {
            _discount = 0;
            _discountPercentage = 0;
          }
        } else if (name === 'qty') {
          // If qty changes, update total discount amount. Price/Item (appliedRate) remains unchanged.
          const discountPerItem = _mrp - _appliedRate;
          _discount = Number((discountPerItem * _qty).toFixed(2));
        } else if (name === 'mrp') {
          // If mrp changes, recalculate discount and appliedRate based on existing percentage
          const discountPerItem = (_mrp * _discountPercentage) / 100;
          _appliedRate = Number((_mrp - discountPerItem).toFixed(2));
          _discount = Number((discountPerItem * _qty).toFixed(2));
        }

        // Final calculations for the row
        const rowAmount = Number((_appliedRate * _qty).toFixed(2));
        const taxedAmount = (rowAmount * _taxPercentage) / 100;
        const finalAmt = rowAmount + taxedAmount;

        return {
          ...row,
          qty: _qty,
          mrp: _mrp,
          appliedRate: _appliedRate,
          discountPercentage: _discountPercentage,
          discount: _discount,
          taxPercentage: _taxPercentage,
          amount: rowAmount.toFixed(2),
          total: finalAmt.toFixed(2),
          cgst: taxType ? 0 : Number((_taxPercentage / 2).toFixed(2)),
          sgst: taxType ? 0 : Number((_taxPercentage / 2).toFixed(2)),
          igst: taxType ? Number(_taxPercentage).toFixed(2) : 0,
          igsttotal: taxType ? taxedAmount.toFixed(2) : "0",
          cgsttotal: taxType ? "" : (taxedAmount / 2).toFixed(2),
          sgsttotal: taxType ? "" : (taxedAmount / 2).toFixed(2),
          [name]: value
        };
      }
      return row;
    });
    setRows(newRows);
  };

  const rowReCalculatioForInventory = (row: any) => {
    const round2 = (n: number) => Math.round(n * 100) / 100;
    let _qty = Number(row.qty) || 0;
    let _taxPercentage = Number(row.taxPercentage) || 0;

    // MRP (batch unitMrp or SKU mrp) is the LIST/ceiling price; the selected sale
    // rate (per-batch GRN sale price or SKU sale price) is the actual Price/Item.
    const realMrp = round2(Number(row.mrp) || 0);
    const saleRate = round2(Number(row.appliedRate) || 0);

    let _mrp: number;
    let _appliedRate: number;
    let _discount: number;
    let _discountPercentage: number;

    if (realMrp > 0 && saleRate > 0 && realMrp >= saleRate) {
      // Retail model: MRP on top, sale rate as Price/Item, discount fills the gap.
      _mrp = realMrp;
      _appliedRate = saleRate;
      const discountPerItem = realMrp - saleRate;
      _discount = round2(discountPerItem * _qty);
      _discountPercentage = round2((discountPerItem / realMrp) * 100);
    } else {
      // No usable MRP, or the sale price is ABOVE MRP (e.g. sold over MRP): fall back
      // to the selected rate as the base price and honour any existing discount %.
      const base = saleRate > 0 ? saleRate : realMrp;
      _mrp = base;
      _discountPercentage = Number(row.discountPercentage) || 0;
      const discountPerItem = (base * _discountPercentage) / 100;
      _discount = round2(discountPerItem * _qty);
      _appliedRate = round2(base - discountPerItem);
    }

    const rowAmount = Number((_appliedRate * _qty).toFixed(2));
    const taxedAmount = (rowAmount * _taxPercentage) / 100;
    const finalAmt = rowAmount + taxedAmount;

    return {
      ...row,
      mrp: _mrp,
      discount: _discount,
      discountPercentage: _discountPercentage.toFixed(2),
      appliedRate: _appliedRate,
      amount: rowAmount.toFixed(2),
      total: finalAmt.toFixed(2),
      cgst: taxType ? 0 : Number((_taxPercentage / 2).toFixed(2)),
      sgst: taxType ? 0 : Number((_taxPercentage / 2).toFixed(2)),
      igst: taxType ? Number(_taxPercentage).toFixed(2) : 0,
      igsttotal: taxType ? taxedAmount.toFixed(2) : "0",
      cgsttotal: taxType ? "" : (taxedAmount / 2).toFixed(2),
      sgsttotal: taxType ? "" : (taxedAmount / 2).toFixed(2),
    };
  };

  return ( <>
  <ItemModel setVisible={setItemModel} visible={itemModel} itemData={getData} onLocationSelect={onLocationSelect} refresh={true}/>
      <Table stickyHeader sx={{ minWidth: 700 }} size='small' aria-label="customized table">
        <TableHead>
          <TableRow>
            <StyledTableCell width={50}>No</StyledTableCell>
            <StyledTableCell width={250}>Item/Description</StyledTableCell>
            <StyledTableCell align="center" width={100}>HSN/SAC</StyledTableCell>
            <StyledTableCell align="center" width={90}>MRP</StyledTableCell>
            <StyledTableCell align="center" width={130}>DISCOUNT</StyledTableCell>
            <StyledTableCell align="center" width={130}>PRICE/ITEM (₹)</StyledTableCell>
            <StyledTableCell align="center" width={100}>QTY</StyledTableCell>
            <StyledTableCell align="center" width={130}>AMOUNT (₹)</StyledTableCell>
            <StyledTableCell align="center" width={150}><><label style={{cursor:'pointer',marginRight:5}}>TAX</label>
            {rows && rows.length ? <> | <label style={{cursor:'pointer',marginLeft:5,marginRight:4}} onClick={() => setTaxType(!taxType)}>IGST</label>
            <ToggleButton
              value="check"
              title='IGST'
              size='small'
              name='taxType'
              className={classes.toggleButton}
              selected={taxType}
              onChange={(e, v) => {
                setTaxType(!taxType);
                // onChange(v, e, 'string');
              }}
            >
              {!taxType ? '' : <CheckIcon style={{fontSize:15}} />}
            </ToggleButton></> : ''}</>
            </StyledTableCell>
            <StyledTableCell align="center" width={150}>FINAL AMOUNT (₹)</StyledTableCell>
            <StyledTableCell align="center" width={110}>
            </StyledTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {/* {console.log("rows", rows)} */}
          {rows && rows.length > 0 && rows.map((e:any, i:any) => 
          <StyledTableRow>
              <StyledTableCell align="center">{e.id}</StyledTableCell>
              <StyledTableCell>
              {e.editable ? 
              <div style={{borderRadius:5,float:'right', fontSize:12,width:100,height:25, color:'#488dff',backgroundColor:'#fef8e6',textAlign:'center',display: 'flex',justifyContent: 'center',alignItems: 'center'}}>
                Editable Row</div> : '' }
                {!e.editable ? <p style={{fontSize:13, marginLeft:5}} onDoubleClick={() => Editable(e.id, true)}>
                  {e.name}<br/><span style={{color:'#9da7b7'}}>{(e.description.length > 50) ? `${e.description.substring(0, 50)}...` : e.description}</span>
                </p> : <><TextField 
                  className='c-text-field' 
                  variant="standard" 
                  autoFocus
                  value={e.name}
                  placeholder='Item Name *'
                  onChange={(v)=> setInvoiceItemText(v.target.value.toString(), 'name', e.id)}
                  size='small'
                  style={{maxWidth:'100%', width: '55%', marginBottom:3}}
                  InputProps={{
                    disableUnderline: true,
                    readOnly: !e.editable,
                    style:{
                      fontSize:12
                    },
                  }} 
                />
                <TextField 
                  className='c-text-field' 
                  variant="standard" 
                  size='small'
                  multiline
                  maxRows={2}
                  style={{width:'100%'}}
                  value={e.description}
                  onChange={(v)=> setInvoiceItemText(v.target.value.toString(), 'description', e.id)}
                  placeholder='Description (Optional)'
                  InputProps={{
                    disableUnderline: true,
                    readOnly: !e.editable,
                    style:{
                      fontSize:12
                    },
                  }} 
                /></>}
              </StyledTableCell>
              <StyledTableCell align="center">
                {!e.editable ? <p style={{fontSize:13}} onDoubleClick={() => Editable(e.id, true)}>
                  #{e.hsnCode}
                </p> : <TextField 
                  className='c-text-field' 
                  variant="standard" 
                  size='small'
                  style={{width:'100%'}}
                  value={e.hsnCode}
                  onChange={(v)=> setInvoiceItemText(v.target.value.toString(), 'hsnCode', e.id)}
                  InputProps={{
                    disableUnderline: true,
                    readOnly: !e.editable,
                    style:{
                      fontSize:12
                    },
                    startAdornment: <InputAdornment position="start"><b style={{paddingBottom:3,fontSize:10}}>#</b></InputAdornment>,
                  }} 
                />}
              </StyledTableCell>
              <StyledTableCell align="center" >
              {!e.editable ? <p style={{fontSize:13}} onDoubleClick={() => Editable(e.id, true)}>
              ₹ {Math.round(Number(e.mrp) * 100) / 100}
                </p> : <TextField
                  className='c-text-field'
                  variant="standard"
                  size='small'
                  value={e.mrp}
                  style={{width:'100%'}}
                  name='mrp'
                  onChange={v => onChange(v, e, 'any')}
                  type='number'
                  InputProps={{
                    disableUnderline: true,
                    readOnly: !e.editable,
                    style:{
                      fontSize:12
                    },
                    startAdornment: <InputAdornment position="start"><b style={{paddingBottom:3,fontSize:10}}>₹</b></InputAdornment>,
                  }}
                />}
              </StyledTableCell>
              <StyledTableCell align="center">
              {!e.editable ? <p style={{fontSize:13}} onDoubleClick={() => Editable(e.id, true)}>
              @{Number(e.discountPercentage)}%<br/>₹ {Number(e.discount)}
                </p> : <><TextField 
                  className='c-text-field' 
                  variant="standard" 
                  size='small'
                  name='discountPercentage'
                  value={Number(e.discountPercentage)}
                  style={{width:'100%',marginBottom:3}}
                  onChange={v => onChange(v, e, 'number')}
                  type='number'
                  onInput = {(e) =>{ 
                    var InputElement = (e.target as HTMLInputElement); 
                    InputElement.value = String(Math.max(0, parseInt(InputElement.value) ).toString().slice(0,2)); 
                  }}
                  InputProps={{
                    disableUnderline: true,
                    readOnly: !e.editable,
                    style:{
                      fontSize:12
                    },
                    startAdornment: <InputAdornment position="start"><b style={{paddingBottom:3,fontSize:10}}>%</b></InputAdornment>
                  }} 
                />
                <TextField 
                  className='c-text-field' 
                  variant="standard" 
                  size='small'
                  name='discount'
                  value={Number(e.discount)}
                  onChange={v => onChange(v, e, 'number')}
                  style={{width:'100%'}}
                  type='number'
                  InputProps={{
                    disableUnderline: true,
                    readOnly: !e.editable,
                    style:{
                      fontSize:12
                    },
                    startAdornment: <InputAdornment position="start"><b style={{paddingBottom:3,fontSize:10}}>₹</b></InputAdornment>
                  }} 
                /></>}
              </StyledTableCell>
              <StyledTableCell align="center">
              {!e.editable ? <p style={{fontSize:13}} onDoubleClick={() => Editable(e.id, true)}>
              ₹ {Math.round(Number(e.appliedRate) * 100) / 100}
                </p> : <TextField
                  className='c-text-field'
                  variant="standard"
                  size='small'
                  name={'appliedRate'}
                  value={e.appliedRate}
                  style={{width:'100%'}}
                  onChange={v => onChange(v, e, 'number')}
                  type='number'
                  InputProps={{
                    disableUnderline: true,
                    readOnly: !e.editable,
                    style:{
                      fontSize:12
                    },
                    startAdornment: <InputAdornment position="start"><b style={{paddingBottom:3,fontSize:10}}>₹</b></InputAdornment>,
                    // endAdornment: <InputAdornment position="end"><b style={{paddingBottom:3,fontSize:12}}>/ - </b></InputAdornment>,
                  }}
                />}
              </StyledTableCell>
              <StyledTableCell align="center">
              {!e.editable ? <p style={{fontSize:13}} onDoubleClick={() => Editable(e.id, true)}>
              {e.qty} {e.unit}
                </p> : <> <TextField 
                  className='c-text-field' 
                  variant="standard" 
                  size='small'
                  name='qty'
                  value={e.qty}
                  style={{width:'100%', marginBottom:3}}
                  onChange={v => onChange(v, e, 'number')}
                  type='number'
                  InputProps={{
                    disableUnderline: true,
                    readOnly: !e.editable,
                    style:{
                      fontSize:12
                    },
                    // endAdornment: <InputAdornment position="end"><b style={{paddingBottom:3,fontSize:12}}>{e.unit}</b></InputAdornment>,
                  }} 
                />
                
                <Select
                  className='c-text-field'
                  variant="standard"
                  size='small'
                  name='unit'
                  displayEmpty
                  disableUnderline
                  value={e.unit || ''}
                  style={{ width: '100%', fontSize: 12 }}
                  onChange={(v: SelectChangeEvent<any>) => changeLineUnit(e, v.target.value.toString())}
                  renderValue={(val: any) => (
                    <span style={{ fontSize: 12 }}>{val || <span style={{ color: '#9da7b7' }}>Unit</span>}</span>
                  )}
                >
                  {unitOptionsFor(e).map((o: any) => (
                    <MenuItem key={o.value} value={o.value} style={{ fontSize: 12 }}>{o.label}</MenuItem>
                  ))}
                </Select> </>}
              </StyledTableCell>
              <StyledTableCell align="center">
              {!e.editable ? <p style={{fontSize:13}} onDoubleClick={() => Editable(e.id, true)}>
              ₹ {e.amount}
                </p> : <TextField 
                  className='c-text-field' 
                  variant="standard" 
                  size='small'
                  name='amount'
                  value={e.amount}
                  style={{width:'100%',textAlign:'right'}}
                  InputProps={{
                    disableUnderline: true,
                    style:{
                      fontSize:12
                    },
                    readOnly: true,
                    startAdornment: <InputAdornment position="start"><b style={{paddingBottom:3,fontSize:12}}>₹</b></InputAdornment>,
                  }} 
                />}
              </StyledTableCell>

              <StyledTableCell align="center">
              {!e.editable ? <p style={{fontSize:13}} onDoubleClick={() => Editable(e.id, true)}>
              @{Number(e.taxPercentage)}%<br/>₹ {Math.round((taxType ? Number(e.igsttotal) : Number(e.cgsttotal)+Number(e.sgsttotal)) * 100) / 100}
                </p> : <><Select
                        className='c-text-field' 
                        disableUnderline
                        size='small'
                        name='taxPercentage'
                        MenuProps={{
                          PaperProps: {
                            sx: {
                              border: "1.5px solid #e9ecf1",
                              // width: 150,
                              boxShadow: 'none',
                              borderRadius: '5px'
                            }
                          }
                        }}
                        onChange={v => onChange(v, e, 'number')}
                        variant='outlined'
                        defaultValue={e.taxPercentage > 0 ? e.taxPercentage : 0}
                        sx={{
                          boxShadow: "none",
                          fontSize:12,
                          height:26,
                          width:'100%',
                          marginTop:'4px',
                          '& .MuiOutlinedInput-input': {p: 0,m:0},
                          '& .MuiSelect-select': { p:0 },
                          marginBottom:'3px',
                          ".MuiOutlinedInput-notchedOutline": { border: 0 },
                          "&.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline":
                            {
                              border: 0,
                            },
                          "&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                            {
                              border: 0,
                            },
                        }}
                        IconComponent={()=> null}
                        readOnly={!e.editable}
                      >
                        {gstOptions && gstOptions.map((option)=> 
                          <MenuItem value={option.value}>{option.lable}</MenuItem>
                        )}
                      </Select>
                {taxType ? <>
                <TextField 
                  className='c-text-field' 
                  variant="standard" 
                  name='igsttotal'
                  size='small'
                  value={e.igsttotal}
                  type='number'
                  InputProps={{
                    disableUnderline: true,
                    style:{
                      fontSize:12
                    },
                    readOnly: true,
                    startAdornment: <InputAdornment position="start"><b style={{paddingBottom:3,fontSize:10,marginRight:-5}}>IGST | ₹</b></InputAdornment>,
                  }} 
                />
                </> : <>
                {/* <Typography> dd -- {e.cgst}</Typography> */}
                <TextField 
                  className='c-text-field' 
                  style={{width:'100%',marginBottom:3}}
                  variant="standard" 
                  size='small'
                  name='cgsttotal'
                  value={Number(e.cgsttotal)+Number(e.sgsttotal)}
                  type='number'
                  InputProps={{
                    disableUnderline: true,
                    style:{
                      fontSize:12
                    },
                    readOnly: true,
                    startAdornment: <InputAdornment position="start"><b style={{paddingBottom:3,fontSize:10,marginRight:-5}}>₹ </b></InputAdornment>,
                  }} 
                />
                
                {/* <TextField 
                  className='c-text-field' 
                  variant="standard" 
                  size='small'
                  name='sgsttotal'
                  value={e.sgsttotal}
                  onDoubleClick={() => Editable(e.id, true)}
                  type='number'
                  InputProps={{
                    disableUnderline: true,
                    style:{
                      fontSize:12
                    },
                    readOnly: true,
                    startAdornment: <InputAdornment position="start"><b style={{paddingBottom:3,fontSize:10,marginRight:-5}}>SGST {e.taxPercentage && e.taxPercentage/2}% | ₹</b></InputAdornment>,
                  }} 
                /> */}
                </> }</>}
              </StyledTableCell>
              <StyledTableCell align="center">
              {!e.editable ? <p style={{fontSize:13}} onDoubleClick={() => Editable(e.id, true)}>
              ₹ {e.total}
                </p> : <TextField 
                  className='c-text-field' 
                  variant="standard" 
                  size='small'
                  name='total'
                  value={e.total}
                  style={{width:'100%',textAlign:'right'}}
                  InputProps={{
                    disableUnderline: true,
                    style:{
                      fontSize:12
                    },
                    readOnly: true,
                    startAdornment: <InputAdornment position="start"><b style={{paddingBottom:3,fontSize:12}}>₹</b></InputAdornment>,
                  }} 
                />}
              </StyledTableCell>
              
              <StyledTableCell align="center" >
                <IconButton size='small' onClick={() => Editable(e.id, true)} style={{marginBottom: '3px', marginRight: '5px', color:'#488dff',backgroundColor:'#f1f0fc',border:'1px solid #488dff',borderRadius:10 }}>
                  <ModeEditOutlineOutlinedIcon style={{fontSize:15}}/>
                </IconButton>
                <IconButton aria-label="Delete" size='small' onClick={() => RemoveRow(e.id)} style={{color:'#c33b3b',backgroundColor:'#fbecec',border:'1px solid #c33b3b',borderRadius:10 }}>
                  <Delete style={{fontSize:15}}/>
                  {/* <RemoveCircleOutlineOutlinedIcon style={{color:'#DC3545'}} /> */}
                </IconButton>
              </StyledTableCell>
          </StyledTableRow>)}
        </TableBody>
        <div style={{scrollMargin:25}} ref={scrollRef}></div>
        {rows && rows.length ?
        <TableFooter>
          <TableRow>
            <StyledTableCell colSpan={2} style={{padding:4}}>
              <Button onClick={()=> setItemModel(true)} size='small' style={{border:'1px dashed grey',borderRadius:5,width:'100%' }} sx={{color:'#545454 !important','&:hover':{color:'#fff !important'}}} variant='outlined'>
                <ArrowCircleDownIcon style={{fontSize:'18px'}}/>
                &nbsp;Load From Inventory
              </Button>
            </StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell align="right">SUBTOTAL</StyledTableCell>
            <StyledTableCell align="center" style={{fontSize:14}}>₹ {subTotal && Number(subTotal.discount).toFixed(2)}</StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell align="center" style={{fontSize:14}}>₹ {subTotal && Number(subTotal.amount).toFixed(2)}</StyledTableCell>
            <StyledTableCell align="center" style={{fontSize:14}}>₹ {subTotal && Number(subTotal.tax).toFixed(2)}</StyledTableCell>
            <StyledTableCell align="center" style={{fontSize:14}}>₹ {subTotal && Number(subTotal.finalAmount).toFixed(2)}</StyledTableCell>
            <StyledTableCell></StyledTableCell>
          </TableRow>
        </TableFooter> : ''}
    </Table>
    {rows && rows.length ? '' :
    <Grid container spacing={0} p={0.5}>
      <Grid item xs={12} >
        <Box onClick={()=> setItemModel(true)} sx={{ p: 1,cursor:'pointer', border: '1px dashed #488dff', borderRadius:'10px', margin:'5px',maxWidth:'100%',color:'#488dff',textAlign:'center',display: 'flex',justifyContent: 'center',alignItems: 'center'}} >
          <AddCircleOutlineOutlinedIcon style={{fontSize:'16px'}}/>&nbsp;CLICK TO ADD ITEM FROM INVENTORY
        </Box>
      </Grid>
      {/* <Grid item xs={2.9} >
        <Box sx={{ p: 1,cursor:'pointer', border: '1px dashed #488dff', borderRadius:'10px', margin:'5px',maxWidth:'100%',color:'#488dff',textAlign:'center',display: 'flex',justifyContent: 'center',alignItems: 'center'}} 
        onClick={AddCustomRow}>
          <AddCircleOutlineOutlinedIcon style={{fontSize:'16px'}}/>&nbsp;ADD EMPTY ROW
        </Box>
      </Grid> */}
    </Grid>}
    </>
)
}

export default TableInlineEdit3;